import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

function root({ className, ...rest }: ComponentProps<'div'>) {
  return <div className={twMerge('mb-20 flex flex-col', className)} {...rest} />
}

function title({ className, ...rest }: ComponentProps<'h1'>) {
  return (
    <h1
      className={twMerge(
        'text-center text-lg font-bold text-monochromatic-500 md:text-start md:text-2xl',
        className,
      )}
      {...rest}
    />
  )
}

function description({ className, ...rest }: ComponentProps<'p'>) {
  return (
    <p
      className={twMerge('my-6 text-center md:text-start', className)}
      {...rest}
    />
  )
}

function rootContent({ className, ...rest }: ComponentProps<'div'>) {
  return (
    <div
      className={twMerge(
        'flex w-full flex-col items-center md:flex-row',
        className,
      )}
      {...rest}
    />
  )
}

interface LabelContentProps extends ComponentProps<'label'> {
  isDragging?: boolean
}

function labelContent({
  className,
  isDragging = false,
  ...rest
}: LabelContentProps) {
  return (
    <label
      className={twMerge(
        'group flex w-full cursor-pointer flex-col items-center gap-2 rounded-lg border-2 border-dashed px-10 py-12 text-center',
        'transition-all hover:border-bios-primary hover:bg-white md:text-start',
        isDragging
          ? 'border-green-500 bg-green-50'
          : 'border-gray-300 bg-monochromatic-200',
        className,
      )}
      {...rest}
    />
  )
}

export const PersonalDocument = {
  Root: root,
  Title: title,
  Description: description,
  RootContent: rootContent,
  Label: labelContent,
}
